export enum Steps {
  CompanyDetails,
  DealDetails,
  Review,
  Success,
}
